import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";
import SectionThree from "../SectionThree";

const DerRichtigeCoachPage = () => {
  const navigate = useNavigate();

  const handleNavigateBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      <div className="bg-gradient-to-r from-[#243949] to-[#517fa4] py-4">
        <div className="container mx-auto px-4">
          <Button 
            variant="ghost" 
            className="text-white hover:bg-white/10 p-2 h-auto group"
            onClick={handleNavigateBack}
          >
            <div className="flex items-center animate-horizontal-bounce">
              <ChevronLeft className="w-4 h-4 mr-1" />
              <ChevronLeft className="w-4 h-4 mr-2 -ml-2" />
            </div>
            Zurück
          </Button>
        </div>
      </div>
      
      <SectionThree />
    </div>
  );
};

export default DerRichtigeCoachPage;
